import { render, staticRenderFns } from "./CopyMoveBox.vue?vue&type=template&id=7656b46d&scoped=true&"
import script from "./CopyMoveBox.vue?vue&type=script&lang=ts&"
export * from "./CopyMoveBox.vue?vue&type=script&lang=ts&"
import style0 from "./CopyMoveBox.vue?vue&type=style&index=0&id=7656b46d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7656b46d",
  null
  
)

export default component.exports